// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"836":"7dbb78c2","843":"b1df59d1","888":"bfc889e2"}[chunkId] + ".chunk.css";
};